<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/training' }">
        <app-i18n code="entities.training.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.training.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.training.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.training.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.training.new.title" v-if="!isEditing"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.title.label"
          :prop="fields.title.name"
          :required="fields.title.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.title.name]" ref="focus" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.description.label"
          :prop="fields.description.name"
          :required="fields.description.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.description.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.date.label"
          :prop="fields.date.name"
          :required="fields.date.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-date-picker placeholder type="datetime" v-model="model[fields.date.name]"></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.hour.label"
          :prop="fields.hour.name"
          :required="fields.hour.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.hour.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.duration.label"
          :prop="fields.duration.name"
          :required="fields.duration.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.duration.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.location.label"
          :prop="fields.location.name"
          :required="fields.location.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.location.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.status.label"
          :prop="fields.status.name"
          :required="fields.status.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.status.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.team.label"
          :prop="fields.team.name"
          :required="fields.team.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-one-input
              :fetchFn="fields.team.fetchFn"
              v-model="model[fields.team.name]"
            ></app-autocomplete-one-input>
          </el-col>
        </el-form-item>

        <el-form-item>
          <div class="form-buttons">
            <el-button
              :disabled="saveLoading"
              @click="doSubmit"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="common.save"></app-i18n>
            </el-button>

            <!-- <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
              <app-i18n code="common.reset"></app-i18n>
            </el-button> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { TrainingModel } from '@modules/training/training-model';

const { fields } = TrainingModel;
const formSchema = new FormSchema([
  fields.id,
  fields.title,
  fields.description,
  fields.date,
  fields.hour,
  fields.duration,
  fields.location,
  fields.status,
  fields.team,
]);

export default {
  name: 'app-training-form-page',

  props: ['id'],

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'training/form/record',
      findLoading: 'training/form/findLoading',
      saveLoading: 'training/form/saveLoading',
    }),

    isEditing() {
      return !!this.id;
    },

    fields() {
      return fields;
    },
  },

  async created() {
    if (this.isEditing) {
      await this.doFind(this.id);
    } else {
      await this.doNew();
    }

    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doFind: 'training/form/doFind',
      doNew: 'training/form/doNew',
      doUpdate: 'training/form/doUpdate',
      doCreate: 'training/form/doCreate',
    }),

    doReset() {
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
        });
      } else {
        return this.doCreate(values);
      }
    },
  },
};
</script>

<style>
</style>
